import Echo from 'laravel-echo';
import {float} from "quill/ui/icons";

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: process.env.MIX_PUSHER_ENCRYPTED,
    forceTLS: !process.env.MIX_PUSHER_ENCRYPTED,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT
});

window.Echo.private(`App.User.${window.App.user}`)
    .listen('.UserTradesUpdated', (e) => {
        window.Livewire.emit('updateShopItem')
    }).listen('.UserDevxBalanceUpdated', (data) => {
        window.Livewire.emit('updateBalance', data.balance)
        // let lastRate = parseFloat($('.last-rate-value').html());
        // $('.my-devx-value').html((data.balance * lastRate).toFixed(2) + ' €');
        // $('.current-value-my-devx').html(data.balance.toFixed(3));
    });

window.Echo.channel('jarvis')
    .listen('.RateDataUpdated', (data) => {
        setRatesData(data);
    })
    .listen('.DemandsAndOffersUpdated', (data) => {
        let idDemandsTable = '#demands-table-values';
        let idDemandsTableMobile = '#demands-table-mobile-values';
        let idOffersTable = '#offers-table-values';
        let idOffersTableMobile = '#offers-table-mobile-values';
        setDemandsTableData(data.data, idDemandsTable);
        setDemandsTableData(data.data, idDemandsTableMobile, true);
        setOffersTableData(data.data, idOffersTable);
        setOffersTableData(data.data, idOffersTableMobile, true);
    });

function setRatesData(data) {
    // $('span.last-rate-value').html(parseFloat(data.rates.last_rate).toFixed(3));
    // $('span.average-rate-value').html(parseFloat(data.rates.average_rate).toFixed(3));
    // $('span.purchase-rate-value').html(parseFloat(data.rates.purchase_rate).toFixed(3));
    // $('span.sales-rate-value').html(parseFloat(data.rates.sales_rate).toFixed(3));
    // if (data.rates.spread) {
    //     $('span.spread-value').html(parseFloat(data.rates.spread).toFixed(3)+'%');
    // } else {
    //     $('span.spread-value').html('-');
    // }
    // $('span.devx-quantity-value').html(parseFloat(data.rates.devx_quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    // $('span.min-treasure-value').html(parseFloat(data.rates.min_treasure).toFixed(2));
    // $('span.max-treasure-value').html(parseFloat(data.rates.max_treasure).toFixed(2));

    Livewire.emit('updateRatesData', data.rates);
    Livewire.emit('updateShopItem');
    Livewire.emit('updateMyDevx');
    Livewire.emit('updateChartData');
    Livewire.emit('updateLastTrades');
}

function setDemandsTableData(data, idTable, mobile = false) {
    let html = '';

    if (data.demands.length > 0) {

        $('#demands-no-data-table').addClass('d-none');

        data.demands.forEach((item, key) => {
            if (key > 9) {
                return;
            }
            // var difference = parseFloat(data.purchaseRate - item.rate);
            html += `<tr>
                    <td class="open-shops-table-body-cell text-nowrap">${parseFloat(item.value).toFixed(2)} DevX</td>
                    <td class="open-shops-table-body-cell front-green">${parseFloat(item.rate).toFixed(3)}</td>`;
            // if (!mobile){
            //     html += `<td class="open-shops-table-body-cell">
            //                 ${Math.abs(parseFloat(difference).toFixed(3))}`;
            //     html +=     checkDifference(difference);
            //     html += `</td>`;
            // }
            html+= `</tr>`;
        });
    } else {
        $('#demands-no-data-table').removeClass('d-none');
    }

    $(idTable).html(html);
}

function setOffersTableData(data, idTable, mobile = false) {
    let html = '';

    if (data.offers.length > 0) {

        $('#offers-no-data-table').addClass('d-none');

        data.offers.forEach((item, key) => {
            if (key > 9) {
                return;
            }
            // var difference = parseFloat(data.salesRate - item.rate);
            html += `<tr>`;
            // if (!mobile) {
            //     html += `<td class="open-shops-table-body-cell">
            //                 ${Math.abs(parseFloat(difference).toFixed(3))}`;
            //     html +=     checkDifference(difference);
            //     html += `</td>`;
            // }
            html += `<td class="open-shops-table-body-cell front-red">${parseFloat(item.rate).toFixed(3)}</td>
                     <td class="open-shops-table-body-cell text-nowrap">${parseFloat(item.value).toFixed(2)} DevX</td>
                 </tr>`;
        });
    } else {
        $('#offers-no-data-table').removeClass('d-none');
    }

    $(idTable).html(html);
}

function checkDifference(difference){
    if(difference < 0) {
        return `&nbsp;<i class="fa-solid fa-arrow-up"></i>`;
    } else if(difference > 0) {
        return `&nbsp;<i class="fa-solid fa-arrow-down"></i>`;
    } else {
        return '';
    }
}
